import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

function HorizontalList ({ children, className, border, justify = 'center' }) {
  const _classNames = [
    'horizontal-list',
    'flex flow-row flex-nowrap',
    border ? 'group divide-x divide-gray-200' : ''
  ]

  const innerClassNames = classNames(
    'flex-grow flex',
    { 'justify-center': justify === 'center' },
    { 'justify-start': justify === 'left' || justify === 'start' },
    { 'justify-end': justify === 'right' || justify === 'end' }
  )

  return (
    <div className={className}>
      <div className={_classNames.join(' ')}>
        {React.Children.map(children, child => {
          return (
            child &&
            <div className={innerClassNames}>
              {React.cloneElement(child)}
            </div>
          )
        })}
      </div>
    </div>
  )
}

HorizontalList.defaultProps = {
  className: '',
  border: true
}

HorizontalList.propTypes = {
  /**
     * Add a custom className to the grid's wrapper
     */
  className: PropTypes.string,
  /**
     * Add a border to the child elements?
     * Default: true
     */
  border: PropTypes.bool
}

export default HorizontalList
